import Aos from 'aos';
import { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import './Contact.css';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: '',
  });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    Aos.init({
      duration: 2000,
      once: false,
    });

    // Add this line to refresh AOS on each re-render
    Aos.refresh();

    // Cleanup function
    return () => {
      Aos.refresh();
    };
  }, []);

  const botToken = process.env.REACT_APP_BOT_TOKEN;
  const chatId = process.env.REACT_APP_BOT_CHAT_ID;

  const handleChanges = event => {
    const { name, value } = event.target;

    setFormData(prev => ({
      ...prev,
      [name]: value,
    }));
  };

  const sendToTelegramBot = async () => {
    const message = `
      Yangi xabar:

      Ism: ${formData.name}

      E-mail: ${formData.email}

      Xabar: ${formData.message}
    `;

    try {
      setLoading(true);
      const res = await fetch(
        `https://api.telegram.org/bot${botToken}/sendMessage`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            chat_id: chatId,
            text: message,
          }),
        }
      );

      setLoading(false);

      if (!res.ok) {
        toast.error('Xabar yuborishda xatolik yuz berdi');
      }
      toast.success('Xabar muvaffaqiyatli yuborildi');
    } catch (error) {
      console.log(error);
      toast.error('Xabar yuborishda xatolik yuz berdi');
    }
  };

  const onSubmit = async event => {
    event.preventDefault();
    await sendToTelegramBot();
    setFormData({
      name: '',
      email: '',
      message: '',
    });
  };
  return (
    <section className="contact container section" id="contact">
      <h2 data-aos="fade-up" className="section__title">
        Get In Touch
      </h2>

      <div data-aos="fade-up" className="contact__container grid">
        <div className="contact__info">
          <h3 className="contact__title">Let's talk about everything!</h3>
          <p className="contact__details">
            Don't like forms? Send me an email. 👋
          </p>
        </div>

        <form onSubmit={onSubmit} className="contact__form">
          <div className="contact__form-group">
            <div className="contact__form-div">
              <input
                onChange={handleChanges}
                type="text"
                className="contact__form-input"
                placeholder="Your Name"
                name="name"
                required
                value={formData.name}
              />
            </div>

            <div className="contact__form-div">
              <input
                onChange={handleChanges}
                type="email"
                className="contact__form-input"
                placeholder="E-mail"
                name="email"
                value={formData.email}
                required
              />
            </div>
          </div>

          <div className="contact__form-div contact__form-area">
            <textarea
              onChange={handleChanges}
              name="message"
              id=""
              cols="30"
              rows="10"
              value={formData.message}
              className="contact__form-input"
              placeholder="Your message"
              required
            ></textarea>
          </div>

          <button className="btn" disabled={loading} type="submit">
            {loading ? 'Loading...' : 'Send a message...'}
          </button>
        </form>
      </div>
    </section>
  );
};

export default Contact;
